import { stringify } from 'query-string';
import { apiFetch } from './utils/api';

export const portfolioLenses = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = stringify(args, { arrayFormat: 'comma' });
    const url = `v3/portfolio/portfolio-lenses?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
